/** 设置面板标签页 */
export const enum E_SETTING_TAB {
  /** 传输设置 */
  transmission = 'transmission',
  /** 服务设置 */
  service = 'service-config',
  /** 版本更新 */
  version = 'service-updating',
  heziclient = 'hezi-client',
  hardwaresettings = 'hardware-settings',
}